<template>
  <div class="finance-trading-card">
    <jr-card :title="title">
      <div class="amount">
        供应商付款
        <p>{{data.payAmount | toFenThousandsAndFloat}}<span>元</span></p>
      </div>
      <el-row :gutter="20">
        <el-col :span="span">
          <div class="info-card info-card-text" v-if="['1', 1].includes(data.status)">待付款，请完成付款并确定出款账户</div>
          <div class="info-card" v-else>
            <div class="title">
              <div>{{data.payAccountName || '-'}}</div>
              <div class="tag" v-if="data.payBankAccountTypeDesc">{{data.payBankAccountTypeDesc}}</div>
            </div>
            <div style="margin: 8px 0 16px">{{data.payBankName || '-'}}</div>
            <page-encrypt-icon
              :value.sync="data[`payAccount-new`]"
              :encryptValue="data.payAccount"
            />
          </div>
        </el-col>
        <el-col :span="2">
          <div class="icon-transfer">
            <icon-svg name="icon-transfer" />
          </div>
        </el-col>
        <el-col :span="span">
          <div class="info-card">
            <div class="title">
              <div>{{data.bankAccountName || '-'}}</div>
              <div class="tag" v-if="data.bankAccountTypeDesc">{{data.bankAccountTypeDesc}}</div>
            </div>
            <div style="margin: 8px 0 16px">{{data.bankName || '-'}}</div>
            <page-encrypt-icon
              :value.sync="data[`bankCardNumber-new`]"
              :encryptValue="data.bankCardNumber"
            />
          </div>
        </el-col>
      </el-row>
    </jr-card>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    span: {
      type: Number,
      default: 6,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style scoped lang="scss">
.info-card-text {
  display: flex;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #C9CCD1;
  line-height: 17px;
  align-items: center;
}
</style>
